(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["business-signup-modal"]) return;
  try {
    
  if (!customElements.get('business-signup-modal')) {
    customElements.define('business-signup-modal', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.formContainer = this.querySelector('.business-signup-dialog__form');
        this.formStatus = this.querySelector('[data-business-signup-status]');
        document.documentElement.classList.add('business-signup-ready');
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-business-signup-open]');
          if (!trigger || this.dialog.open) return;
          this.opener = trigger;
          this.dialog.showModal();
          document.documentElement.classList.add('business-signup-open');
          this.checkFormLoading();
        }, options);
        this.querySelector('[data-business-signup-retry]').addEventListener('click', () => window.location.reload(), options);
        this.querySelector('[data-business-signup-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('pointerdown', (event) => {
          this.backdropPressed = event.target === this.dialog;
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog && this.backdropPressed) this.dialog.close();
        }, options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') event.stopPropagation();
        }, options);
        this.dialog.addEventListener('close', () => {
          clearTimeout(this.formCheckTimer);
          document.documentElement.classList.remove('business-signup-open');
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target.contains(this) && !this.dialog.open) {
            this.dialog.showModal();
            this.checkFormLoading();
          }
        }, options);
      }
      checkFormLoading() {
        clearTimeout(this.formCheckTimer);
        if (this.formLoaded) return;
        const started = Date.now();
        const loading = this.querySelector('[data-business-signup-loading]');
        const error = this.querySelector('[data-business-signup-error]');
        loading.hidden = false;
        error.hidden = true;
        const check = () => {
          // Shopify Forms renders its native form in an open shadow root.
          const embeddedForm = this.formContainer.querySelector('shopify-forms-embed')?.shadowRoot?.querySelector('form');
          const form = embeddedForm || this.formContainer.querySelector('form');
          const submit = form?.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');
          // Shopify Forms uses type="text" with id="email" for its email field.
          if (form?.querySelector('input#email, input[type="email"]') && (submit?.textContent.trim() || submit?.value)) {
            this.enhanceForm(form);
            this.formLoaded = true;
            this.formStatus.hidden = true;
            return;
          }
          if (Date.now() - started >= 12000) {
            loading.hidden = true;
            error.hidden = false;
          }
          // Continue checking while open so a slow form can still recover.
          this.formCheckTimer = setTimeout(check, 300);
        };
        check();
      }
      enhanceForm(form) {
        if (this.enhancedForm === form) return;
        this.enhancedForm = form;
        const root = form.getRootNode();
        const style = document.createElement('style');
        style.textContent = `
          [data-business-native-source], [data-business-native-field] [role="listbox"] { display: none !important; }
          select[data-business-native-select] {
            display: block; width: 100%; min-height: 54px; box-sizing: border-box;
            padding: 14px 15px; margin: 0; border: 1px solid #20202033; border-radius: 5px;
            font: normal 400 16px Arial, sans-serif; color: #202020; background-color: #fff;
            appearance: auto; -webkit-appearance: menulist;
          }
          select[data-business-native-select]:focus { outline: 2px solid #0c1a94; outline-offset: -1px; }
        `;
        (root instanceof ShadowRoot ? root : form).append(style);
        const sync = () => this.syncBusinessType(form);
        this.formObserver?.disconnect();
        this.formObserver = new MutationObserver(sync);
        this.formObserver.observe(form, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-expanded', 'aria-disabled'] });
        form.addEventListener('submit', (event) => {
          const field = this.businessType;
          if (!field?.select?.isConnected) return;
          if (field.pending || !field.select.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal: this.events.signal });
        sync();
      }
      syncBusinessType(form) {
        const source = form.querySelector('button[aria-labelledby~="custom#business_type-selector-label"]');
        if (!source) return;
        let field = this.businessType;
        if (field?.source !== source) {
          field?.select?.remove();
          clearTimeout(this.selectSyncTimer);
          field = this.businessType = { source, container: source.parentElement, select: null, pending: null, choiceSent: false };
          field.container.setAttribute('data-business-native-field', '');
          if (source.getAttribute('aria-expanded') !== 'true') source.click();
          else this.syncBusinessType(form);
          return;
        }
        const options = Array.from(field.container.querySelectorAll('[role="option"]'));
        const valueNode = field.container.querySelector('[id="custom#business_type-selector-value"]');
        const current = valueNode?.textContent.trim() || '';
        if (field.select && !field.select.isConnected) {
          field.select = null;
          field.pending = null;
          clearTimeout(this.selectSyncTimer);
          source.removeAttribute('data-business-native-source');
          if (source.getAttribute('aria-expanded') !== 'true') {
            source.click();
            return;
          }
        }
        if (!field.select && options.length) {
          const select = document.createElement('select');
          select.setAttribute('data-business-native-select', '');
          select.setAttribute('aria-labelledby', 'custom#business_type-selector-label');
          select.required = true;
          const placeholder = new Option(field.container.querySelector('[id="custom#business_type-selector-label"]').textContent, '');
          placeholder.disabled = true;
          select.add(placeholder);
          options.forEach(option => select.add(new Option(option.textContent.trim(), option.textContent.trim())));
          select.value = current;
          field.select = select;
          source.before(select);
          source.setAttribute('data-business-native-source', '');
          select.addEventListener('change', () => {
            field.pending = select.value;
            field.choiceSent = false;
            clearTimeout(this.selectSyncTimer);
            this.selectSyncTimer = setTimeout(() => {
              if (!field.pending) return;
              field.select.remove();
              field.select = null;
              field.pending = null;
              source.removeAttribute('data-business-native-source');
              field.container.removeAttribute('data-business-native-field');
              this.formObserver.disconnect();
              source.focus({ preventScroll: true });
            }, 3000);
            if (source.getAttribute('aria-expanded') !== 'true') source.click();
            this.syncBusinessType(form);
          }, { signal: this.events.signal });
          if (source.getAttribute('aria-expanded') === 'true') source.click();
          return;
        }
        if (!field.select) return;
        if (field.pending) {
          if (current === field.pending) {
            field.pending = null;
            clearTimeout(this.selectSyncTimer);
          } else if (!field.choiceSent) {
            const option = options.find(item => item.textContent.trim() === field.pending);
            if (option) {
              field.choiceSent = true;
              option.click();
            }
          }
        } else {
          field.select.value = current;
        }
        field.select.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      }
      disconnectedCallback() {
        clearTimeout(this.formCheckTimer);
        clearTimeout(this.selectSyncTimer);
        this.formObserver?.disconnect();
        this.events?.abort();
        document.documentElement.classList.remove('business-signup-ready', 'business-signup-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partify-vehicle-history"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-vhr-form]'), vin = root.querySelector('[data-vhr-vin]'), confirm = root.querySelector('[data-vhr-confirm]');
    const button = root.querySelector('[data-vhr-submit]'), status = root.querySelector('[data-vhr-status]');
    const enabled = root.dataset.enabled === 'true', routeRoot = window.Shopify?.routes?.root || '/';
    let busy = false, confirmedVin = '';
    const normalized = () => vin.value.trim().toUpperCase();
    function refresh() { button.disabled = busy || !enabled || !/^[A-HJ-NPR-Z0-9]{17}$/.test(normalized()) || !confirm.checked || confirmedVin !== normalized(); button.setAttribute('aria-busy', String(busy)); }
    vin.addEventListener('input', () => { confirm.checked = false; confirmedVin = ''; refresh(); });
    confirm.addEventListener('change', () => { confirmedVin = confirm.checked ? normalized() : ''; refresh(); });
    async function json(path, options = {}) {
      const response = await fetch(routeRoot + path, { credentials: 'same-origin', cache: 'no-store', ...options,
        headers: { Accept: 'application/json', ...options.headers }, signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('We couldn’t prepare checkout. Please try again; we’ll check your cart first.');
      return response.json();
    }
    form.addEventListener('submit', async event => {
      event.preventDefault(); refresh(); if (button.disabled) return;
      const selectedVin = confirmedVin; busy = true; refresh(); status.textContent = 'Preparing your report purchase…';
      try {
        const [product, cart] = await Promise.all([json(`products/${encodeURIComponent(root.dataset.product)}.js`), json('cart.js')]);
        const variant = product.variants?.find(item => String(item.id) === root.dataset.variant);
        if (cart.currency !== 'USD' || !variant?.available || variant.sku !== root.dataset.sku || variant.requires_shipping !== false || variant.price !== Number(root.dataset.price) || variant.price <= 0) throw new Error('This report is currently unavailable. Please check back soon.');
        if (normalized() !== selectedVin || !confirm.checked || confirmedVin !== selectedVin) throw new Error('Your VIN changed. Check it and confirm again.');
        const properties = { VIN: selectedVin, _vhr_schema: '1', _vhr_confirmed_vin: selectedVin,
          _digital_access_key: Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, '0')).join('') };
        const existing = cart.items?.find(item => String(item.variant_id) === root.dataset.variant && item.properties?.VIN === selectedVin && item.properties?._vhr_schema === '1' && item.properties?._vhr_confirmed_vin === selectedVin);
        if (existing && existing.quantity !== 1) await json('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: existing.key, quantity: 1 }) });
        if (!existing) await json('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties }] }) });
        else if (!/^[a-f0-9]{64}$/.test(existing.properties?._digital_access_key || '')) await json('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: existing.key, quantity: 1, properties: { ...existing.properties, _digital_access_key: properties._digital_access_key } }) });
        if (normalized() !== selectedVin || !confirm.checked) throw new Error('Your VIN changed. Review the report VIN in your cart before checkout.');
        window.location.assign(routeRoot + 'checkout');
      } catch (error) { busy = false; status.textContent = error.name === 'TimeoutError' ? 'Checkout took too long. Try again; we’ll check your cart first.' : error.message; refresh(); }
    });
    window.addEventListener('pageshow', () => { busy = false; refresh(); });
    refresh();
  }
  const initialize = scope => scope.querySelectorAll('[data-vehicle-history]').forEach(init);
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partify-vehicle-services"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const buttons = [...root.querySelectorAll('[data-service-option]')];
    function select(service, updateHash) {
      if (!['paint', 'history'].includes(service)) return;
      root.dataset.service = service;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.serviceOption === service)));
      if (updateHash) history.replaceState(null, '', location.pathname + location.search + (service === 'history' ? '#vehicle-history' : '#paint-code'));
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      select(button.dataset.serviceOption, true);
      const panel = document.querySelector(button.dataset.serviceOption === 'history' ? '[data-vehicle-history]' : '[data-paint-code-lookup]');
      panel?.scrollIntoView({ block: 'start', behavior: 'instant' });
    }));
    const fromHash = () => select(location.hash === '#vehicle-history' ? 'history' : 'paint', false);
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }
  document.querySelectorAll('[data-vehicle-services]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vehicle-services]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    "use strict";

    function initLanding(root) {
      if (!root || root.__whlReady) return;
      root.__whlReady = true;

      const sticky = root.querySelector("[data-whl-sticky]");
      const hero = root.querySelector("[data-whl-hero]");
      const revealItems = Array.prototype.slice.call(root.querySelectorAll(".whl-reveal"));

      // Reveal on scroll
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });
        revealItems.forEach(function (item, index) {
          item.style.transitionDelay = Math.min(index * 40, 200) + "ms";
          observer.observe(item);
        });
      } else {
        revealItems.forEach(function (item) { item.classList.add("is-visible"); });
      }

      // Sticky CTA appears after the hero
      function updateSticky() {
        if (!sticky || !hero) return;
        const trigger = hero.offsetTop + hero.offsetHeight * 0.85;
        const visible = window.scrollY > trigger;
        sticky.classList.toggle("is-visible", visible);
        sticky.setAttribute("aria-hidden", visible ? "false" : "true");
      }

      if (sticky && hero) {
        updateSticky();
        window.addEventListener("scroll", updateSticky, { passive: true });
        window.addEventListener("resize", updateSticky);
      }

      // FAQ accordion: keep one open at a time
      const faqItems = Array.prototype.slice.call(root.querySelectorAll("[data-whl-faq] details"));
      faqItems.forEach(function (detail) {
        detail.addEventListener("toggle", function () {
          if (!detail.open) return;
          faqItems.forEach(function (other) {
            if (other !== detail) other.open = false;
          });
        });
      });
    }

    function boot() {
      Array.prototype.slice
        .call(document.querySelectorAll("[data-whl-landing]"))
        .forEach(initLanding);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }

    document.addEventListener("shopify:section:load", function (event) {
      const el = event.target.querySelector("[data-whl-landing]");
      if (el) initLanding(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-tax-form"]) return;
  try {
    
  (() => {
    const multiStates = new Set([
      'AK',
      'AL',
      'AR',
      'AZ',
      'CA',
      'CO',
      'CT',
      'FL',
      'GA',
      'HI',
      'ID',
      'IL',
      'IA',
      'KS',
      'KY',
      'ME',
      'MD',
      'MI',
      'MN',
      'MO',
      'NE',
      'NV',
      'NJ',
      'NM',
      'NC',
      'ND',
      'OH',
      'OK',
      'PA',
      'RI',
      'SC',
      'SD',
      'TN',
      'TX',
      'UT',
      'VT',
      'WA',
      'WI',
    ]);
    const noFormStates = new Set(['DE', 'MT', 'NH', 'OR']);

    function initializeSection(section) {
      if (!section || section.dataset.taxFormInitialized === 'true') return;

      const select = section.querySelector('[data-tax-state]');
      const title = section.querySelector('[data-tax-title]');
      const description = section.querySelector('[data-tax-description]');
      const note = section.querySelector('[data-tax-note]');
      const download = section.querySelector('[data-tax-download]');
      const filesElement = section.querySelector('[data-tax-form-files]');
      if (!select || !title || !description || !note || !download || !filesElement) return;

      const files = JSON.parse(filesElement.textContent);

      function reset() {
        title.textContent = section.dataset.initialTitle;
        description.textContent = section.dataset.initialDescription;
        note.hidden = true;
        download.hidden = true;
        download.removeAttribute('href');
      }

      function updateState() {
        const stateCode = select.value;
        const stateName = select.selectedOptions[0]?.textContent || '';
        if (!stateCode) {
          reset();
          return;
        }

        if (noFormStates.has(stateCode)) {
          title.textContent = section.dataset.noFormTitle;
          description.textContent = section.dataset.noFormDescription;
          note.hidden = true;
          download.hidden = true;
          download.removeAttribute('href');
          return;
        }

        if (stateCode === 'MS') {
          title.textContent = section.dataset.mississippiTitle;
          description.textContent = section.dataset.mississippiDescription;
          note.hidden = true;
          download.hidden = true;
          download.removeAttribute('href');
          return;
        }

        const fileUrl = files[stateName];
        title.textContent = multiStates.has(stateCode)
          ? section.dataset.multiTitle
          : section.dataset.stateTitle.replace('[state]', stateName);
        description.textContent = fileUrl ? section.dataset.formDescription : section.dataset.missingDescription;
        note.textContent = section.dataset.formNote;
        note.hidden = !fileUrl;
        download.href = fileUrl || '';
        download.hidden = !fileUrl;
      }

      section.dataset.taxFormInitialized = 'true';
      select.addEventListener('change', updateState);
      updateState();
    }

    function initializeAll() {
      document.querySelectorAll('[data-wholesale-tax-form]').forEach(initializeSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeSection(event.target.querySelector('[data-wholesale-tax-form]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
